import httpClient from "./httpClient";

const base = "/public/student-portal";

export function view(customStudentId, instituteId, academicYear) {
  return httpClient.get(`${base}/view`, { params: { customStudentId, instituteId, academicYear } }).then((res) => res.data.data);
}

export function invoiceList(identificationId, instituteId) {
  return httpClient.get(`${base}/invoices`, { params: { identificationId, instituteId } }).then((res) => res.data.data);
}

export function moneyReceipt(invoiceId, instituteId) {
  return httpClient.get(`${base}/money-receipt`, { params: { invoiceId, instituteId } }).then((res) => res.data.data);
}
